/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const TwitterSettingsDtoReplySettingsEnum = {
    everyone: "everyone",
    following: "following",
    mentionedUsers: "mentionedUsers",
    subscribers: "subscribers",
    verified: "verified"
} as const;

export type TwitterSettingsDtoReplySettingsEnumKey = (typeof TwitterSettingsDtoReplySettingsEnum)[keyof typeof TwitterSettingsDtoReplySettingsEnum];

export type TwitterSettingsDto = {
    /**
     * @description Controls who can reply to the tweet
     * @default "everyone"
     * @type string
    */
    replySettings?: TwitterSettingsDtoReplySettingsEnumKey | null;
};